import gql from 'graphql-tag';
import { buildFilter } from '../../Common/utils';
import { client } from '../../apollo';

export async function OperationsGraphQL(data) {
  const QUERY = gql`
    query {
      operations ${buildFilter(data)} {
        id
        amount
        description
        protocol
        type
        createdAt
        status
      }
    }
  `;

  

  try {
    const { data } = await client.query({
      query: QUERY,
    });

    return data;
  } catch(error) {
    const msg = error.message.replace("GraphQL error: ", "")
    console.log(msg);
    throw msg
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/graphql.js